import "./dots.css";

export default function Dots({active = 0,qtd =1}) {
  return (
    <div className="dots">
      {[...Array(qtd).keys()].map((i) => (
        <div key={`dots_${i}`} className={`dot ${i === active?"active":""}`}>
            <b>0{i + 1}</b>
        </div>
      ))}
    </div>
  );
}
